<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
    <form action="" method="" name="PINform" id="PINform" autocomplete="off" draggable="true">
        <input id="PINbox" type="password" [value]="userEnteredPinCode" name="PINbox" disabled />
        <br />
        <input type="button" class="PINbutton" name="1" value="1" id="1" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="2" value="2" id="2" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="3" value="3" id="3" (click)="addNumber($event);" />
        <br />
        <input type="button" class="PINbutton" name="4" value="4" id="4" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="5" value="5" id="5" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="6" value="6" id="6" (click)="addNumber($event);" />
        <br />
        <input type="button" class="PINbutton" name="7" value="7" id="7" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="8" value="8" id="8" (click)="addNumber($event);" />
        <input type="button" class="PINbutton" name="9" value="9" id="9" (click)="addNumber($event);" />
        <br />
        <input type="button" class="PINbutton clear" name="-" value="clear" id="-" (click)="clearForm();" />
        <input type="button" class="PINbutton" name="0" value="0" id="0" (click)="addNumber($event);" />
        <input type="button" class="PINbutton enter" name="+" value="enter" id="+" cdkFocusInitial
            (click)="submitForm();" />
    </form>
</div>
<div mat-dialog-actions>
    <!-- <button mat-raised-button color="primary" (click)="onNoClick()">No</button> -->
    <!-- <button mat-raised-button color="primary" class="critical" [mat-dialog-close]="true" cdkFocusInitial>Yes</button> -->
</div>
